import { QueryClient } from '@tanstack/react-query';

/**
 * 전역 QueryClientProvider에서 사용되는 QueryClient입니다.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: false,
      retry: (failureCount, error) => {
        try {
          // FIXME error generic추가
          if (
            // @ts-ignore
            error.status !== 500 ||
            process.env.NODE_ENV === 'development' ||
            failureCount >= 2
          ) {
            return false;
          }

          return true;
        } catch (e) {
          console.log(e);
        }
      },
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
});
